import { Guid } from '@web/utils';
import { ShippingMethodCode } from '../../shared/enums/shipping-method-code';

export class PublicShippingMethod {
  public constructor(
    private readonly data: {
      id: Guid;
      code: ShippingMethodCode;
      category: string;
      name: string;
      description: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get code(): ShippingMethodCode {
    return this.data.code;
  }

  public get name(): string {
    return this.data.name;
  }

  public get description(): string {
    return this.data.description;
  }

  public get category(): string {
    return this.data.category;
  }
}
